const defaultSchoolsLocations = [
  {
    id: 'none',
    label: '',
    schools: [
      {
        id: 'acorn-woodland-elementary-school',
        name: 'Acorn Woodland Elementary School',
        address: '1025 81st Avenue, 94621',
        zipcode: '94621',
        search: '/s?address=1025%2081st%20Avenue%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.758012576385354%2C-122.18034714840982%2C37.749029423614644%2C-122.19170885159016&origin=37.753521%2C-122.186028',
      },
      {
        id: 'allendale-elementary-school',
        name: 'Allendale Elementary School',
        address: '3670 Penniman Avenue, 94619',
        zipcode: '94619',
        search: '/s?address=3670%20Penniman%20Avenue%2C%20Oakland%2C%20California%2094619%2C%20United%20States&bounds=37.792985576385355%2C-122.19920746086997%2C37.784002423614645%2C-122.21057453913004&origin=37.788494%2C-122.204891',
      },
      {
        id: 'bella-vista-elementary-school',
        name: 'Bella Vista Elementary School',
        address: '1025 East 28th Street, 94610',
        zipcode: '94610',
        search: '/s?address=1025%20East%2028th%20Street%2C%20Oakland%2C%20California%2094610%2C%20United%20States&bounds=37.80478957638535%2C-122.23157555272594%2C37.79580642361464%2C-122.24294444727407&origin=37.800298%2C-122.23726',
      },
      {
        id: 'bret-harte-middle-school',
        name: 'Bret Harte Middle School',
        address: '3700 Coolidge Avenue, 94602',
        zipcode: '94602',
        search: '/s?address=3700%20Coolidge%20Avenue%2C%20Oakland%2C%20California%2094602%2C%20United%20States&bounds=37.80418157638535%2C-122.20100759951558%2C37.79519842361464%2C-122.21237640048443&origin=37.79969%2C-122.206692',
      },
      {
        id: 'bridges-academy-at-melrose',
        name: 'Bridges Academy At Melrose',
        address: '1325 53rd Avenue, 94601',
        zipcode: '94601',
        search: '/s?address=1325%2053rd%20Avenue%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.77191357638536%2C-122.20135508072961%2C37.76293042361465%2C-122.21271891927039&origin=37.767422%2C-122.207037',
      },
      {
        id: 'brookfield-elementary-school',
        name: 'Brookfield Elementary School',
        address: '401 Jones Ave, 94603',
        zipcode: '94603',
        search: '/s?address=401%20Jones%20Avenue%2C%20Oakland%2C%20California%2094603%2C%20United%20States&bounds=37.73934857638535%2C-122.18341858076053%2C37.73036542361464%2C-122.19477741923947&origin=37.734857%2C-122.189098',
      },
      {
        id: 'burckhalter-elementary-school',
        name: 'Burckhalter Elementary School',
        address: '3994 Burckhalter Avenue, 94605',
        zipcode: '94605',
        search: '/s?address=3994%20Burckhalter%20Avenue%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.779674576385354%2C-122.16157448431812%2C37.77069142361464%2C-122.17293951568189&origin=37.775183%2C-122.167257',
      },
      {
        id: 'carl-munck-elementary-school',
        name: 'Carl Munck Elementary School',
        address: '11900 Campus Drive, 94619',
        zipcode: '94619',
        search: '/s?address=11900%20Campus%20Drive%2C%20Oakland%2C%20California%2094619%2C%20United%20States&bounds=37.79971557638535%2C-122.16838394316068%2C37.79073242361464%2C-122.17975205683933&origin=37.795224%2C-122.174068',
      },
      {
        id: 'castlemont-high-school',
        name: 'Castlemont High School',
        address: '8601 MacArthur Boulevard, 94605',
        zipcode: '94605',
        search: '/s?address=8601%20Macarthur%20Boulevard%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.762802576385354%2C-122.15760578059216%2C37.753819423614644%2C-122.16896821940783&origin=37.758311%2C-122.163287',
      },
      {
        id: 'chabot-elementary-school',
        name: 'Chabot Elementary School',
        address: '6686 Chabot Road, 94618',
        zipcode: '94618',
        search: '/s?address=6686%20Chabot%20Road%2C%20Oakland%2C%20California%2094618%2C%20United%20States&bounds=37.85456457638536%2C-122.23711571742139%2C37.84558142361465%2C-122.24849228257862&origin=37.850073%2C-122.242804',
      },
      {
        id: 'claremont-middle-school',
        name: 'Claremont Middle School',
        address: '5750 College Avenue, 94618',
        zipcode: '94618',
        search: '/s?address=5750%20College%20Avenue%2C%20Oakland%2C%20California%2094618%2C%20United%20States&bounds=37.84986357638535%2C-122.24573908005164%2C37.84088042361464%2C-122.25711491994838&origin=37.845372%2C-122.251427',
      },
      {
        id: 'coliseum-college-prep-academy',
        name: 'Coliseum College Prep Academy',
        address: '1390 66th Avenue, 94621',
        zipcode: '94621',
        search: '/s?address=1390%2066th%20Avenue%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.766184576385356%2C-122.18751652084032%2C37.757201423614646%2C-122.19887947915967&origin=37.761693%2C-122.193198',
      },
      {
        id: 'crocker-highlands-elementary-school',
        name: 'Crocker Highlands Elementary School',
        address: '525 Midcrest Road, 94610',
        zipcode: '94610',
        search: '/s?address=525%20Midcrest%20Road%2C%20Oakland%2C%20California%2094610%2C%20United%20States&bounds=37.815595576385356%2C-122.22190972089724%2C37.806612423614645%2C-122.23328027910274&origin=37.811104%2C-122.227595',
      },
      {
        id: 'dewey-academy',
        name: 'Dewey Academy',
        address: '1111 Second Avenue, 94606',
        zipcode: '94606',
        search: '/s?address=1111%202nd%20Avenue%2C%20Oakland%2C%20California%2094606%2C%20United%20States&bounds=37.801417576385354%2C-122.25273481220593%2C37.792434423614644%2C-122.26410318779408&origin=37.796926%2C-122.258419',
      },
      {
        id: 'east-oakland-pride-elementary-school',
        name: 'East Oakland Pride Elementary School',
        address: '8000 Birch Street, 94621',
        zipcode: '94621',
        search: '/s?address=8000%20Birch%20Street%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.763950576385355%2C-122.1690726924258%2C37.754967423614644%2C-122.18043530757419&origin=37.759459%2C-122.174754',
      },
      {
        id: 'edna-brewer-middle-school',
        name: 'Edna Brewer Middle School',
        address: '3748 13th Avenue, 94610',
        zipcode: '94610',
        search: '/s?address=3748%2013th%20Avenue%2C%20Oakland%2C%20California%2094610%2C%20United%20States&bounds=37.808301576385354%2C-122.22372728242665%2C37.79931842361464%2C-122.23509671757334&origin=37.80381%2C-122.229412',
      },
      {
        id: 'elmhurst-united-middle-school',
        name: 'Elmhurst United Middle School',
        address: '1800 98th Avenue, 94603',
        zipcode: '94603',
        search: '/s?address=1800%2098th%20Avenue%2C%20Oakland%2C%20California%2094603%2C%20United%20States&bounds=37.750543576385354%2C-122.15950372177008%2C37.741560423614644%2C-122.17086427822991&origin=37.746052%2C-122.165184',
      },
      {
        id: 'emerson-elementary-school',
        name: 'Emerson Elementary School',
        address: '4803 Lawton Avenue, 94609',
        zipcode: '94609',
        search: '/s?address=4803%20Lawton%20Avenue%2C%20Oakland%2C%20California%2094609%2C%20United%20States&bounds=37.83887657638535%2C-122.25232692724782%2C37.82989342361464%2C-122.26370107275218&origin=37.834385%2C-122.258014',
      },
      {
        id: 'encompass-academy',
        name: 'Encompass Academy',
        address: '1025 81st Avenue, 94621',
        zipcode: '94621',
        search: '/s?address=1025%2081st%20Avenue%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.758012576385354%2C-122.18034714840982%2C37.749029423614644%2C-122.19170885159016&origin=37.753521%2C-122.186028',
      },
      {
        id: 'esperanza-elementary-school',
        name: 'Esperanza Elementary School',
        address: '10315 E Street, 94603',
        zipcode: '94603',
        search: '/s?address=10315%20East%20Street%2C%20Oakland%2C%20California%2094603%2C%20United%20States&bounds=37.74167357638535%2C-122.1679544024029%2C37.73269042361464%2C-122.17931359759712&origin=37.737182%2C-122.173634',
      },
      {
        id: 'franklin-elementary-school',
        name: 'Franklin Elementary School',
        address: '915 Foothill Boulevard, 94606',
        zipcode: '94606',
        search: '/s?address=915%20Foothill%20Boulevard%2C%20Oakland%2C%20California%2094606%2C%20United%20States&bounds=37.79799357638535%2C-122.243019075643%2C37.78901042361464%2C-122.25438692435701&origin=37.793502%2C-122.248703',
      },
      {
        id: 'fred-t-korematsu-discovery-academy',
        name: 'Fred T. Korematsu Discovery Academy',
        address: '10315 E St, Oakland, CA 94603',
        zipcode: '94603',
        search: '/s?address=10315%20East%20Street%2C%20Oakland%2C%20California%2094603%2C%20United%20States&bounds=37.74167357638535%2C-122.1679544024029%2C37.73269042361464%2C-122.17931359759712&origin=37.737182%2C-122.173634',
      },
      {
        id: 'fremont-high-school',
        name: 'Fremont High School',
        address: '4610 Foothill Boulevard, 94601',
        zipcode: '94601',
        search: '/s?address=4610%20Foothill%20Boulevard%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.778925576385355%2C-122.20346254188671%2C37.769942423614644%2C-122.2148274581133&origin=37.774434%2C-122.209145',
      },
      {
        id: 'frick-united-academy-of-language',
        name: 'Frick United Academy of Language',
        address: '2845 64th Avenue, 94605',
        zipcode: '94605',
        search: '/s?address=2845%2064th%20Avenue%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.775945576385354%2C-122.17812577091014%2C37.76696242361464%2C-122.18949022908986&origin=37.771454%2C-122.183808',
      },
      {
        id: 'fruitvale-elementary-school',
        name: 'Fruitvale Elementary School',
        address: '3200 Boston Avenue, 94602',
        zipcode: '94602',
        search: '/s?address=3200%20Boston%20Avenue%2C%20Oakland%2C%20California%2094602%2C%20United%20States&bounds=37.80077157638536%2C-122.20816586191154%2C37.79178842361465%2C-122.21953413808845&origin=37.79628%2C-122.21385',
      },
      {
        id: 'garfield-elementary-school',
        name: 'Garfield Elementary School',
        address: '1640 22nd Avenue, 94606',
        zipcode: '94606',
        search: '/s?address=1640%2022nd%20Avenue%2C%20Oakland%2C%20California%2094606%2C%20United%20States&bounds=37.79111357638536%2C-122.23005060484398%2C37.782130423614646%2C-122.241417395156&origin=37.786622%2C-122.235734',
      },
      {
        id: 'gateway-to-college-at-laney-college',
        name: 'Gateway to College at Laney College',
        address: '900 Fallon Street, 94607',
        zipcode: '94607',
        search: '/s?address=900%20Fallon%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.80064257638536%2C-122.2556628718371%2C37.79165942361465%2C-122.2670311281629&origin=37.796151%2C-122.261347',
      },
      {
        id: 'glenview-elementary-school',
        name: 'Glenview Elementary School',
        address: '4215 La Cresta Avenue, 94602',
        zipcode: '94602',
        search: '/s?address=4215%20La%20Cresta%20Avenue%2C%20Oakland%2C%20California%2094602%2C%20United%20States&bounds=37.81014357638536%2C-122.21349414063924%2C37.80116042361465%2C-122.22486385936075&origin=37.805652%2C-122.219179',
      },
      {
        id: 'global-family-elementary-school',
        name: 'Global Family Elementary School',
        address: '2035 40th Avenue, 94601',
        zipcode: '94601',
        search: '/s?address=2035%2040th%20Avenue%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.784224576385355%2C-122.20737213455642%2C37.775241423614645%2C-122.21873786544357&origin=37.779733%2C-122.213055',
      },
      {
        id: 'grass-valley-elementary-school',
        name: 'Grass Valley Elementary School',
        address: '4720 Dunkirk Avenue, 94605',
        zipcode: '94605',
        search: '/s?address=4720%20Dunkirk%20Avenue%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.757561576385356%2C-122.11958918303702%2C37.748578423614646%2C-122.13095081696298&origin=37.75307%2C-122.12527',
      },
      {
        id: 'greenleaf-k-8-school',
        name: 'Greenleaf K-8 School',
        address: '6328 East 17th Street, 94621',
        zipcode: '94621',
        search: '/s?address=6328%20East%2017th%20Street%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.76896357638535%2C-122.18880130736882%2C37.75998042361464%2C-122.20016469263119&origin=37.764472%2C-122.194483',
      },
      {
        id: 'highland-community-school',
        name: 'Highland Community School',
        address: '8521 A Street, 94621',
        zipcode: '94621',
        search: '/s?address=8521%20A%20Street%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.75615357638536%2C-122.17383029113643%2C37.74717042361465%2C-122.18519170886358&origin=37.751662%2C-122.179511',
      },
      {
        id: 'hillcrest-elementary-school',
        name: 'Hillcrest Elementary School',
        address: '30 Marguerite Drive, 94618',
        zipcode: '94618',
        search: '/s?address=30%20Marguerite%20Drive%2C%20Oakland%2C%20California%2094618%2C%20United%20States&bounds=37.84495357638536%2C-122.22705345871368%2C37.83597042361465%2C-122.23842854128632&origin=37.840462%2C-122.232741',
      },
      {
        id: 'hoover-elementary-school',
        name: 'Hoover Elementary School',
        address: '890 Brockhurst Street, 94608',
        zipcode: '94608',
        search: '/s?address=890%20Brockhurst%20Street%2C%20Oakland%2C%20California%2094608%2C%20United%20States&bounds=37.82776557638535%2C-122.26857878353627%2C37.81878242361464%2C-122.27995121646373&origin=37.823274%2C-122.274265',
      },
      {
        id: 'horace-mann-elementary-school',
        name: 'Horace Mann Elementary School',
        address: '5222 Ygnacio Avenue, 94601',
        zipcode: '94601',
        search: '/s?address=5222%20Ygnacio%20Avenue%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.77816357638535%2C-122.19667860045229%2C37.76918042361464%2C-122.2080433995477&origin=37.773672%2C-122.202361',
      },
      {
        id: 'international-community-school',
        name: 'International Community School',
        address: '2825 International Blvd, 94601',
        zipcode: '94601',
        search: '/s?address=2825%20International%20Boulevard%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.783945576385356%2C-122.22513115600562%2C37.774962423614646%2C-122.23649684399437&origin=37.779454%2C-122.230814',
      },
      {
        id: 'joaquin-miller-elementary-school',
        name: 'Joaquin Miller Elementary School',
        address: '5525 Ascot Drive, 94611',
        zipcode: '94611',
        search: '/s?address=5525%20Ascot%20Drive%2C%20Oakland%2C%20California%2094611%2C%20United%20States&bounds=37.82333657638536%2C-122.19602312473334%2C37.81435342361465%2C-122.20739487526664&origin=37.818845%2C-122.201709',
      },
      {
        id: 'la-escuelita-elementary-school',
        name: 'La Escuelita Elementary School',
        address: '1050 Second Ave, 94606',
        zipcode: '94606',
        search: '/s?address=1050%202nd%20Avenue%2C%20Oakland%2C%20California%2094606%2C%20United%20States&bounds=37.80080757638535%2C-122.25275385914162%2C37.79182442361464%2C-122.26412214085838&origin=37.796316%2C-122.258438',
      },
      {
        id: 'laurel-elementary-school',
        name: 'Laurel Elementary School',
        address: '3750 Brown Avenue, 94619',
        zipcode: '94619',
        search: '/s?address=3750%20Brown%20Avenue%2C%20Oakland%2C%20California%2094619%2C%20United%20States&bounds=37.79750757638536%2C-122.19076511303143%2C37.788524423614646%2C-122.20213288696857&origin=37.793016%2C-122.196449',
      },
      {
        id: 'life-academy',
        name: 'Life Academy',
        address: '2101 35th Avenue, 94601',
        zipcode: '94601',
        search: '/s?address=2101%2035th%20Avenue%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.789132576385356%2C-122.21064475718656%2C37.780149423614645%2C-122.22201124281345&origin=37.784641%2C-122.216328',
      },
      {
        id: 'lincoln-elementary-school',
        name: 'Lincoln Elementary School',
        address: '225 11th Street, 94607',
        zipcode: '94607',
        search: '/s?address=225%2010th%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.80375957638535%2C-122.26189863199045%2C37.79477642361464%2C-122.27326736800956&origin=37.799268%2C-122.267583',
      },
      {
        id: 'lockwood-steam-academy',
        name: 'Lockwood Steam Academy',
        address: '6701 International Boulevard, 94621',
        zipcode: '94621',
        search: '/s?address=6701%20International%20Boulevard%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.76499557638535%2C-122.18746361216549%2C37.75601242361464%2C-122.19882638783452&origin=37.760504%2C-122.193145',
      },
      {
        id: 'madison-park-academy-primary',
        name: 'Madison Park Academy Primary',
        address: '470 El Paseo Drive, 94603',
        zipcode: '94603',
        search: '/s?address=470%20El%20Paseo%20Drive%2C%20Oakland%2C%20California%2094603%2C%20United%20States&bounds=37.732475576385355%2C-122.17090910788855%2C37.723492423614644%2C-122.18226689211144&origin=37.727984%2C-122.176588',
      },
      {
        id: 'madison-park-academy-upper',
        name: 'Madison Park Academy Upper',
        address: '400 Capistrano Dr, Oakland, CA 94603',
        zipcode: '94603',
        search: '/s?address=400%20Capistrano%20Drive%2C%20Oakland%2C%20California%2094603%2C%20United%20States&bounds=37.732632576385356%2C-122.17168509584937%2C37.723649423614646%2C-122.18304290415062&origin=37.728141%2C-122.177364',
      },
      {
        id: 'manzanita-community-school',
        name: 'Manzanita Community School',
        address: '2409 East 27th Street, 94601',
        zipcode: '94601',
        search: '/s?address=2409%20East%2027th%20Street%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.79621457638535%2C-122.21917621249875%2C37.78723142361464%2C-122.23054378750126&origin=37.791723%2C-122.22486',
      },
      {
        id: 'manzanita-seed-elementary-school',
        name: 'Manzanita Seed Elementary School',
        address: '2409 East 27th Street, 94601',
        zipcode: '94601',
        search: '/s?address=2409%20East%2027th%20Street%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.79621457638535%2C-122.21917621249875%2C37.78723142361464%2C-122.23054378750126&origin=37.791723%2C-122.22486',
      },
      {
        id: 'markham-elementary-school',
        name: 'Markham Elementary School',
        address: '7220 Krause Avenue, 94605',
        zipcode: '94605',
        search: '/s?address=7220%20Krause%20Avenue%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.770006576385356%2C-122.1729652272422%2C37.761023423614645%2C-122.1843287727578&origin=37.765515%2C-122.178647',
      },
      {
        id: 'martin-luther-king-jr-elementary-school',
        name: 'Martin Luther King, Jr. Elementary School',
        address: '960 10th Street, 94607',
        zipcode: '94607',
        search: '/s?address=960%2010th%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.810805576385356%2C-122.27709008967882%2C37.801822423614645%2C-122.28845991032118&origin=37.806314%2C-122.282775',
      },
      {
        id: 'mcclymonds-high-school',
        name: 'McClymonds High School',
        address: '2607 Myrtle Street, 94607',
        zipcode: '94607',
        search: '/s?address=2607%20Myrtle%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.82358157638536%2C-122.27271810586123%2C37.81459842361465%2C-122.28408989413876&origin=37.81909%2C-122.278404',
      },
      {
        id: 'melrose-leadership-academy',
        name: 'Melrose Leadership Academy',
        address: '4730 Fleming Avenue, 94619',
        zipcode: '94619',
        search: '/s?address=4730%20Fleming%20Avenue%2C%20Oakland%2C%20California%2094619%2C%20United%20States&bounds=37.784787576385355%2C-122.19207009127274%2C37.775804423614645%2C-122.20343590872727&origin=37.780296%2C-122.197753',
      },
      {
        id: 'metwest-high-school',
        name: 'Metwest High School',
        address: '314 East 10th Street, 94606',
        zipcode: '94606',
        search: '/s?address=314%20East%2010th%20Street%2C%20Oakland%2C%20California%2094606%2C%20United%20States&bounds=37.79977557638536%2C-122.25216893854434%2C37.79079242361465%2C-122.26353706145565&origin=37.795284%2C-122.257853',
      },
      {
        id: 'montclair-elementary-school',
        name: 'Montclair Elementary School',
        address: '1757 Mountain Boulevard, 94611',
        zipcode: '94611',
        search: '/s?address=1757%20Mountain%20Boulevard%2C%20Oakland%2C%20California%2094611%2C%20United%20States&bounds=37.835889576385355%2C-122.20769015749251%2C37.826906423614645%2C-122.21906384250748&origin=37.831398%2C-122.213377',
      },
      {
        id: 'montera-middle-school',
        name: 'Montera Middle School',
        address: '5555 Ascot Drive, 94611',
        zipcode: '94611',
        search: '/s?address=5555%20Ascot%20Drive%2C%20Oakland%2C%20California%2094611%2C%20United%20States&bounds=37.82403757638536%2C-122.19603307073537%2C37.81505442361465%2C-122.20740492926463&origin=37.819546%2C-122.201719',
      },
      {
        id: 'oakland-academy-of-knowledge',
        name: 'Oakland Academy of Knowledge',
        address: '8755 Fontaine Street, 94605',
        zipcode: '94605',
        search: '/s?address=8755%20Fontaine%20Street%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.76888757638535%2C-122.14674831320721%2C37.75990442361464%2C-122.15811168679278&origin=37.764396%2C-122.15243',
      },
      {
        id: 'oakland-high-school',
        name: 'Oakland High School',
        address: '1023 MacArthur Boulevard, 94610',
        zipcode: '94610',
        search: '/s?address=1023%20Macarthur%20Boulevard%2C%20Oakland%2C%20California%2094610%2C%20United%20States&bounds=37.808863576385356%2C-122.23088223916822%2C37.799880423614646%2C-122.24225176083176&origin=37.804372%2C-122.236567',
      },
      {
        id: 'oakland-international-high-school',
        name: 'Oakland International High School',
        address: '4521 Webster Street, 94609',
        zipcode: '94609',
        search: '/s?address=4521%20Webster%20Street%2C%20Oakland%2C%20California%2094609%2C%20United%20States&bounds=37.838203576385354%2C-122.25472597912714%2C37.82922042361464%2C-122.26610002087286&origin=37.833712%2C-122.260413',
      },
      {
        id: 'oakland-technical-high-school',
        name: 'Oakland Technical High School',
        address: '4351 Broadway, 94611',
        zipcode: '94611',
        search: '/s?address=4351%20Broadway%2C%20Oakland%2C%20California%2094611%2C%20United%20States&bounds=37.83676557638535%2C-122.24977708997199%2C37.82778242361464%2C-122.26115091002802&origin=37.832274%2C-122.255464',
      },
      {
        id: 'peralta-elementary-school',
        name: 'Peralta Elementary School',
        address: '460 63rd Street, 94609',
        zipcode: '94609',
        search: '/s?address=460%2063rd%20Street%2C%20Oakland%2C%20California%2094609%2C%20United%20States&bounds=37.854182576385355%2C-122.25317074689163%2C37.845199423614645%2C-122.26454725310838&origin=37.849691%2C-122.258859',
      },
      {
        id: 'piedmont-avenue-elementary-school',
        name: 'Piedmont Avenue Elementary School',
        address: '4314 Piedmont Avenue, 94611',
        zipcode: '94611',
        search: '/s?address=4314%20Piedmont%20Avenue%2C%20San%20Francisco%20Bay%20Area%2C%20California%2094611%2C%20United%20States&bounds=37.83335057638536%2C-122.24297835317755%2C37.824367423614646%2C-122.25435164682246&origin=37.828859%2C-122.248665',
      },
      {
        id: 'prescott-elementary-school',
        name: 'Prescott Elementary School',
        address: '920 Campbell Street, 94607',
        zipcode: '94607',
        search: '/s?address=920%20Campbell%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.81275157638535%2C-122.29224293986705%2C37.80376842361464%2C-122.30361306013295&origin=37.80826%2C-122.297928',
      },
      {
        id: 'ralph-j-bunche-academy',
        name: 'Ralph J. Bunche Academy',
        address: '991 - 14th Street, 94607',
        zipcode: '94607',
        search: '/s?address=991%2014th%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.81286657638535%2C-122.27638893101339%2C37.80388342361464%2C-122.2877590689866&origin=37.808375%2C-122.282074',
      },
      {
        id: 'reach-academy',
        name: 'Reach Academy',
        address: '9845 Bancroft Avenue, 94603',
        zipcode: '94603',
        search: '/s?address=9845%20Bancroft%20Avenue%2C%20Oakland%2C%20California%2094603%2C%20United%20States&bounds=37.75123457638536%2C-122.15547366873415%2C37.74225142361465%2C-122.16683433126585&origin=37.746743%2C-122.161154',
      },
      {
        id: 'redwood-heights-elementary-school',
        name: 'Redwood Heights Elementary School',
        address: '4401 39th Avenue, 94619',
        zipcode: '94619',
        search: '/s?address=4401%2039th%20Avenue%2C%20Oakland%2C%20California%2094619%2C%20United%20States&bounds=37.801825576385355%2C-122.18037578081207%2C37.792842423614644%2C-122.19174421918792&origin=37.797334%2C-122.18606',
      },
      {
        id: 'roosevelt-middle-school',
        name: 'Roosevelt Middle School',
        address: '1926 19th Avenue, 94606',
        zipcode: '94606',
        search: '/s?address=1926%2019th%20Avenue%2C%20San%20Francisco%2C%20California%2094116%2C%20United%20States&bounds=37.75633057638535%2C-122.47024727754764%2C37.74734742361464%2C-122.48160872245235&origin=37.751839%2C-122.475928',
      },
      {
        id: 'rudsdale-continuation-school-including-newcomer',
        name: 'Rudsdale Continuation School including Newcomer',
        address: '8251 Fontaine Street, 94605',
        zipcode: '94605',
        search: '/s?address=8251%20Fontaine%20Street%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.77046657638535%2C-122.14807319190221%2C37.76148342361464%2C-122.1594368080978&origin=37.765975%2C-122.153755',
      },
      {
        id: 'special-education',
        name: 'Special Education',
        address: '915 54th Street, 94608',
        zipcode: '94608',
        search: '/s?address=915%2054th%20Street%2C%20Oakland%2C%20California%2094608%2C%20United%20States&bounds=37.84265457638536%2C-122.2688446359822%2C37.833671423614646%2C-122.28021936401778&origin=37.838163%2C-122.274532',
      },
      {
        id: 'sankofa-united-elementary-school',
        name: 'Sankofa United Elementary School',
        address: '581 61st Street, 94609',
        zipcode: '94609',
        search: '/s?address=581%2061st%20Street%2C%20Oakland%2C%20California%2094609%2C%20United%20States&bounds=37.851565576385354%2C-122.25914994877088%2C37.842582423614644%2C-122.27052605122911&origin=37.847074%2C-122.264838',
      },
      {
        id: 'sequoia-elementary-school',
        name: 'Sequoia Elementary School',
        address: '3730 Lincoln Avenue, 94602',
        zipcode: '94602',
        search: '/s?address=3730%20Lincoln%20Avenue%2C%20Oakland%2C%20California%2094602%2C%20United%20States&bounds=37.806950576385354%2C-122.20517038641124%2C37.797967423614644%2C-122.21653961358875&origin=37.802459%2C-122.210855',
      },
      {
        id: 'skyline-high-school',
        name: 'Skyline High School',
        address: '12250 Skyline Boulevard, 94619',
        zipcode: '94619',
        search: '/s?address=12250%20Skyline%20Boulevard%2C%20Oakland%2C%20California%2094619%2C%20United%20States&bounds=37.803564576385355%2C-122.15593064699637%2C37.794581423614645%2C-122.16729935300363&origin=37.799073%2C-122.161615',
      },
      {
        id: 'sojourner-truth',
        name: 'Sojourner Truth',
        address: '8251 Fontaine Street, 94605',
        zipcode: '94605',
        search: '/s?address=8251%20Fontaine%20Street%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.77046657638535%2C-122.14807319190221%2C37.76148342361464%2C-122.1594368080978&origin=37.765975%2C-122.153755',
      },
      {
        id: 'street-academy',
        name: 'Street Academy',
        address: '417 29th Street, 94609',
        zipcode: '94609',
        search: '/s?address=417%2029th%20Street%2C%20Oakland%2C%20California%2094609%2C%20United%20States&bounds=37.82188657638535%2C-122.2599202364208%2C37.81290342361464%2C-122.27129176357921&origin=37.817395%2C-122.265606',
      },
      {
        id: 'think-college-now-elementary-school',
        name: 'Think College Now Elementary School',
        address: '2825 International Boulevard, 94601',
        zipcode: '94601',
        search: '/s?address=2825%20International%20Boulevard%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.783945576385356%2C-122.22513115600562%2C37.774962423614646%2C-122.23649684399437&origin=37.779454%2C-122.230814',
      },
      {
        id: 'thornhill-elementary-school',
        name: 'Thornhill Elementary School',
        address: '5880 Thornhill Drive, 94611',
        zipcode: '94611',
        search: '/s?address=5880%20Thornhill%20Drive%2C%20Oakland%2C%20California%2094611%2C%20United%20States&bounds=37.84068057638535%2C-122.20553678817491%2C37.83169742361464%2C-122.21691121182509&origin=37.836189%2C-122.211224',
      },
      {
        id: 'united-for-success-academy',
        name: 'United for Success Academy',
        address: '2101 35th Avenue, 94601',
        zipcode: '94601',
        search: '/s?address=2101%2035th%20Avenue%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.789132576385356%2C-122.21064475718656%2C37.780149423614645%2C-122.22201124281345&origin=37.784641%2C-122.216328',
      },
      {
        id: 'urban-promise-academy',
        name: 'Urban Promise Academy',
        address: '3031 East 18th Street, 94601',
        zipcode: '94601',
        search: '/s?address=3031%20East%2018th%20Street%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.78659257638535%2C-122.21904895249538%2C37.77760942361464%2C-122.23041504750462&origin=37.782101%2C-122.224732',
      },
      {
        id: 'west-oakland-middle-school',
        name: 'West Oakland Middle School',
        address: '991 14th Street, 94607',
        zipcode: '94607',
        search: '/s?address=991%2014th%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.81286657638535%2C-122.27638893101339%2C37.80388342361464%2C-122.2877590689866&origin=37.808375%2C-122.282074',
      },
      {
        id: 'westlake-middle-school',
        name: 'Westlake Middle School',
        address: '2629 Harrison Street, 94612',
        zipcode: '94612',
        search: '/s?address=2629%20Harrison%20Street%2C%20Oakland%2C%20California%2094612%2C%20United%20States&bounds=37.81912957638536%2C-122.25544944875882%2C37.81014642361465%2C-122.26682055124117&origin=37.814638%2C-122.261135',
      },
      {
        id: 'young-adult-program',
        name: 'Young Adult Program',
        address: '915 54th Street, 94608',
        zipcode: '94608',
        search: '/s?address=915%2054th%20Street%2C%20Oakland%2C%20California%2094608%2C%20United%20States&bounds=37.84265457638536%2C-122.2688446359822%2C37.833671423614646%2C-122.28021936401778&origin=37.838163%2C-122.274532',
      },
    ]
  },
  {
    id: 'early-childhood-education',
    label: 'EARLY CHILDHOOD EDUCATION',
    schools: [
      {
        id: 'acorn-woodland-cdc',
        name: 'Acorn Woodland CDC',
        address: '1025 81st Avenue, 94621',
        zipcode: '94621',
        search: '/s?address=1025%2081st%20Avenue%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.758012576385354%2C-122.18034714840982%2C37.749029423614644%2C-122.19170885159016&origin=37.753521%2C-122.186028',
      },
      {
        id: 'arroyo-viejo-cdc',
        name: 'Arroyo Viejo CDC',
        address: '1895 78th Avenue, 94621',
        zipcode: '94621',
        search: '/s?address=1895%2078th%20Avenue%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.76594457638536%2C-122.17182253927477%2C37.75696142361465%2C-122.18318546072523&origin=37.761453%2C-122.177504',
      },
      {
        id: 'burbank-preschool-center',
        name: 'Burbank Preschool Center',
        address: '3550 64th Avenue, 94605',
        zipcode: '94605',
        search: '/s?address=3550%2064th%20Avenue%2C%20Oakland%2C%20California%2094605%2C%20United%20States&bounds=37.77970057638535%2C-122.17155948231971%2C37.77071742361464%2C-122.1829245176803&origin=37.775209%2C-122.177242',
      },
      {
        id: 'centro-infantil-cdc',
        name: 'Centro Infantil CDC',
        address: '2660 East 16th Street, 94601',
        zipcode: '94601',
        search: '/s?address=2660%20East%2016th%20Street%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.78714257638536%2C-122.22418491020619%2C37.778159423614646%2C-122.2355510897938&origin=37.782651%2C-122.229868',
      },
      {
        id: 'harriet-tubman-cdc',
        name: 'Harriet Tubman CDC',
        address: '800 33rd Street, 94608',
        zipcode: '94608',
        search: '/s?address=800%2033rd%20Street%2C%20Oakland%2C%20California%2094608%2C%20United%20States&bounds=37.828105576385354%2C-122.26785575734058%2C37.819122423614644%2C-122.27922824265943&origin=37.823614%2C-122.273542',
      },
      {
        id: 'yuk-yau-cdc',
        name: 'Yuk Yau CDC',
        address: '291 10th Street, 94607',
        zipcode: '94607',
        search: '/s?address=291%2010th%20Street%2C%20Oakland%2C%20California%2094607%2C%20United%20States&bounds=37.80432357638536%2C-122.26326558858786%2C37.79534042361465%2C-122.27463441141215&origin=37.799832%2C-122.26895',
      },
      {
        id: 'lockwood-cdc',
        name: 'Lockwood CDC',
        address: '1125 69th Avenue, 94621',
        zipcode: '94621',
        search: '/s?address=1125%2069th%20Avenue%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.76363757638536%2C-122.1872307164647%2C37.754654423614646%2C-122.19859328353532&origin=37.759146%2C-122.192912',
      },
      {
        id: 'highland-cdc',
        name: 'Highland CDC',
        address: '1322 86th Avenue, 94621',
        zipcode: '94621',
        search: '/s?address=1322%2086th%20Avenue%2C%20Oakland%2C%20California%2094621%2C%20United%20States&bounds=37.756501576385354%2C-122.17175726441937%2C37.74751842361464%2C-122.18311873558062&origin=37.75201%2C-122.177438',
      },
      {
        id: 'international-cdc',
        name: 'International CDC',
        address: '2825 International Boulevard, 94601',
        zipcode: '94601',
        search: '/s?address=2825%20International%20Boulevard%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.783945576385356%2C-122.22513115600562%2C37.774962423614646%2C-122.23649684399437&origin=37.779454%2C-122.230814',
      },
      {
        id: 'emerson-cdc',
        name: 'Emerson CDC',
        address: '4801 Lawton Avenue, 94609',
        zipcode: '94609',
        search: '/s?address=4801%20Lawton%20Avenue%2C%20Oakland%2C%20California%2094609%2C%20United%20States&bounds=37.83906557638536%2C-122.25236691267813%2C37.83008242361465%2C-122.26374108732188&origin=37.834574%2C-122.258054',
      },
      {
        id: 'united-nation-cdc',
        name: 'United Nation CDC',
        address: '1025 4th Avenue, 94606',
        zipcode: '94606',
        search: '/s?address=1025%204th%20Avenue%2C%20Oakland%2C%20California%2094606%2C%20United%20States&bounds=37.799317576385356%2C-122.25163597378187%2C37.790334423614645%2C-122.26300402621814&origin=37.794826%2C-122.25732',
      },
      {
        id: 'hintil-laurel-cdc',
        name: 'Hintil / Laurel CDC',
        address: '11850 Campus Drive, 94619',
        zipcode: '94619',
        search: '/s?address=11850%20Campus%20Drive%2C%20Oakland%2C%20California%2094619%2C%20United%20States&bounds=37.79918957638535%2C-122.16947398362976%2C37.79020642361464%2C-122.18084201637024&origin=37.794698%2C-122.175158',
      },
      {
        id: 'manzanita-cdc',
        name: 'Manzanita CDC',
        address: '2618 Grande Vista Avenue, 94601',
        zipcode: '94601',
        search: '/s?address=2618%20Grande%20Vista%20Avenue%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.796635576385356%2C-122.22031418011296%2C37.787652423614645%2C-122.23168181988704&origin=37.792144%2C-122.225998',
      },
      {
        id: 'jefferson-cdc',
        name: 'Jefferson CDC',
        address: '1975 40th Avenue, 94601',
        zipcode: '94601',
        search: '/s?address=1975%2040th%20Avenue%2C%20Oakland%2C%20California%2094601%2C%20United%20States&bounds=37.78298757638535%2C-122.2087372296533%2C37.77400442361464%2C-122.22010277034671&origin=37.778496%2C-122.21442',
      },
      {
        id: 'kaiser-early-childhood-center',
        name: 'Kaiser Early Childhood Center',
        address: '25 S Hill Court, Oakland, 94618',
        zipcode: '94618',
        search: '/s?address=25%20South%20Hill%20Court%2C%20Oakland%2C%20California%2094618%2C%20United%20States&bounds=37.85720057638535%2C-122.2255405140461%2C37.84821742361464%2C-122.2369174859539&origin=37.852709%2C-122.231229',
      },
    ],
  },
];
export default defaultSchoolsLocations;
